import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=6ec411fc&scoped=true"
import script from "./Tips.vue?vue&type=script&lang=js"
export * from "./Tips.vue?vue&type=script&lang=js"
import style0 from "./Tips.vue?vue&type=style&index=0&id=6ec411fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec411fc",
  null
  
)

export default component.exports